// extracted by mini-css-extract-plugin
module.exports = {"overlay":"popups_overlay__2p2vt","fadein":"popups_fadein__rkIXo","popup":"popups_popup__fJvGs","popup__action":"popups_popup__action__3JTgw"};